import api from "./api";

export const obtenerPerfil = async () => {
    const response = await api.get("/Usuario/Perfil");

    return response.data.data;
}

export const cambiarClave = async (claveActual, claveNueva) => {
    await api.post("/Usuario/CambiarClave", { claveActual, claveNueva });
}

// Mantenimiento de usuarios.
export const getsUsuarioView = async (filters) => {
    const response = await api.get("/Usuario/GetsUsuarioView", { params: filters });

    return response.data.data;
}

// Un usuario con su persona, si tiene clave cargada y sus roles.
export const getUsuario = async (codigo) => {
    const response = await api.get("/Usuario/GetUsuario", { params: { codigo } });

    return response.data.data;
}

// Alta o modificacion. La clave solo se cambia si viene informada.
export const addUpdateUsuario = async (usuario) => {
    const response = await api.post("/Usuario/AddUpdateUsuario", usuario);

    return response.data.data;
}

// Asigna los roles del usuario: IdEstado 2 lo concede, 3 lo quita. Se mandan
// todos juntos para que no queden roles a medias.
export const addUpdateUsuarioRoles = async (codigo, roles) => {
    const response = await api.post("/Usuario/AddUpdateUsuarioRoles?codigo=" + encodeURIComponent(codigo), roles);

    return response.data.data;
}

// Listado de filiales para el filtro de usuarios.
export const getFilialesList = async () => {
    const response = await api.get("/Filial/GetsList");

    return response.data.data;
}
